import { useAuth0 } from "@auth0/auth0-react";
import { PrimaryButton } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { AuthHeading } from "./AuthHeading";
import { AuthLayout } from "./AuthLayout";

export function AccountDeletedPage() {
  const { t } = useTranslation();
  const { logout } = useAuth0();

  const handleOnClick = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <AuthLayout>
      <AuthHeading
        title={t("Your Certn account is now deleted")}
        subtitle={t(
          "We're sorry to see you go, but we hope to see you again some day."
        )}
      />

      <PrimaryButton
        fullWidth
        type="button"
        size="large"
        onPress={handleOnClick}
        testID="account-delete-page-sign-up-button"
      >
        {t("Sign up to Certn")}
      </PrimaryButton>
    </AuthLayout>
  );
}
